import { gql } from "@apollo/client";

export const UPDATE_PROCUREMENT_REQUEST_STATUS = gql`
  mutation updateProcurementItemStatus($id: ID!, $itemId: ID!, $status: String!) {
    updateProcurementItemStatus(id: $id, itemId: $itemId, status: $status) {
      message
    }
  }
`;